import { Box, Typography } from "@mui/material";
import React from "react";
import PrimaryIcon from "./PrimaryIcon";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";

const Warning = ({ children, showAlert = true }) => {
  return (
    <>
      <Box
        sx={(theme) => ({
          background: theme.palette.yellow.main,
          borderRadius: "8px",
        })}
        display={"flex"}
        alignItems={"center"}
        gap={"10px"}
        padding={"10px 16px"}
      >
        {showAlert && (
          <PrimaryIcon icon={AlertIcon} width="20px" height="20px" />
        )}
        {children}
      </Box>
    </>
  );
};

export default Warning;
